import React from "react";
import '../../../App.scss';
import backgroundImage from "../../../assets/images/main_background.png";
import GreenBtn from "../../../assets/images/btn_green_store.png";
import EmptyWood from "../../../assets/images/empty_wood_btn.png";
import GoldBanner from "../../../assets/images/gold_banner.png";
import Grid from "@material-ui/core/Grid";
import SingleOffer from "../../pageComponents/Market/SingleOffer";
import Toolbar from "../../Toolbar";
import {connect} from "react-redux";
import {data} from "../../../Store/Actions/DataAction";
import {dialog} from "../../../Store/Actions/DialogAction";
import axios from "axios";
import {shopGet} from "../../../Utility/Url";
import PicoLoader from "../../pageComponents/Common/PicoLoader";
import ShopDialog from "../../pageComponents/Common/ShopDialog";
import DialogContent from "@material-ui/core/DialogContent";
import Dialog from "@material-ui/core/Dialog";
import RedBtn from "../../../assets/images/btn_red_store.png";
import {
    avatarDialogBackgroundColor,
    avatarDialogContentColor, dialogBackground,
    dialogBorderColor, dialogContentColor,
    dialogContentTextColor
} from "../../../Utility/Theme";
import CustomDialog from "../../pageComponents/Common/Dialog";
import {withRouter} from "react-router-dom";
import {COINCHANGE} from "../../../Store/Actions/Types";
import qs from 'qs'
class MarketIndex extends React.Component{
    constructor() {
        super();
        this.state= {
            appHasLoaded: false,
            marketDataLoaded:false,
            dialogDetail:null,
            resDialog:false,
            resDialogText:'',
            resDialogDetail:{},
            showDialog:false,
            style: {
                completed: 5,
                root: {
                    flexGrow: 1,
                    backgroundImage: "url(" + backgroundImage + ")",
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundBlendMode:'soft-light',
                    width: '100%',
                    backgroundColor: "#3A80FD",
                    flex:1,
                    minHeight:'0'
                },
                singleOfferPriceSection:{
                    backgroundImage:"url("+GreenBtn+")",
                    backgroundSize: '100% 90%',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: '50% 50%'
                }
            }
        }

    }
    fetchData= async()=>{
        await axios.get(`users/data`)
            .then(res => {
                const {data}=res
                this.props.data(data)
                // this.props.data(5,SILVERUP)

            }).catch(error=>{
                    console.log(error.toString())
                }
            )
    }
    fetchShopItems= async()=>{
        await axios.get(shopGet)
            .then(res => {
                const {data}=res
                console.log(data)
                this.setState({
                    marketDataLoaded:data
                })
            }).catch(error=>{
                    console.log(error.toString())
                }
            )
    }
    openDialog=(data)=>{
        this.setState({
            dialogDetail:data,
            showDialog:true
        })
    }
    handleShopDialogAction=(action)=>{
        switch (action) {
            case '#cancel':
                this.setState({
                    resDialog:false,
                })
                break
            default:
                this.setState({
                    showDialog:false,
                })
        }
    }
    async componentDidMount() {
        const s=new URLSearchParams(this.props.location.search).get("status")
        let queryParamValue=qs.parse(this.props.location.pathname, { ignoreQueryPrefix: true })
        queryParamValue=queryParamValue[Object.keys(queryParamValue)[0]]
        if (queryParamValue!==''){
            switch (queryParamValue){
                case 'false':{
                    const dialogObject= {
                        dialog:{
                            id: 0,
                            icon:'',
                            title: "خطا",
                            message: `پرداخت با موفقت انجام نشد`,
                            ok: null,
                            cancel: {
                                text: "باشه",
                                action: "#ok"
                            },
                            style: {
                                type: "danger",
                                borderColor: dialogBorderColor,
                                background: dialogBackground,
                                contentColor: dialogContentColor,
                                contentTextColor: dialogContentTextColor
                            }
                        }
                    }
                    const dialog={
                        button:{
                            text:'',
                            backgroundColor:'transparent',
                            bottomFontSize:'15px',
                            buttonTextColor:'red',
                            borderColor:'transparent'
                        },
                        data:{
                            dialog:dialogObject.dialog,
                        },
                        visible:true
                    }
                    this.props.dialog(dialog)
                }
                    break
                case 'true':
                {
                    const dialogObject= {
                        dialog:{
                            id: 0,
                            icon:'',
                            title: "خطا",
                            message: `پرداخت با موفقت انجام شد`,
                            ok: null,
                            cancel: {
                                text: "باشه",
                                action: "#ok"
                            },
                            style: {
                                type: "danger",
                                borderColor: dialogBorderColor,
                                background: dialogBackground,
                                contentColor: dialogContentColor,
                                contentTextColor: dialogContentTextColor
                            }
                        }
                    }
                    const dialog={
                        button:{
                            text:'',
                            backgroundColor:'transparent',
                            bottomFontSize:'15px',
                            buttonTextColor:'red',
                            borderColor:'transparent'
                        },
                        data:{
                            dialog:dialogObject.dialog,
                        },
                        visible:true
                    }
                    this.props.dialog(dialog)
                }
                    break
                default:return
            }
             const path = localStorage.getItem('redirect')
            if (path){
                localStorage.removeItem('redirect')
                this.props.history.push(path)
            }
        }

        console.log(queryParamValue,typeof queryParamValue)

        // if (queryParamValue!=='' && queryParamValue){
        //     //check local storage
        // }
        // alert(queryParamValue)
        await this.fetchData()
        await this.fetchShopItems()
        const{id}=this.props.match.params
        this.props.toggleBottomNavbar(true)
        console.log("AAAAAAAAAAAAAAAAAA",this.props)

        if (id){
            console.log('hast')
            let text=''
            switch (id){
                case 'success':
                    text=''
                    this.setState({
                        resDialogText:'پرداخت با موفقیت انجام شد',
                        resDialog:true
                    })
                    break
                case 'fail':
                    text=''
                    this.setState({
                        resDialogText:'پرداخت با موفقیت انجام نشد',
                        resDialog:true
                    })
                    break
            }
        }

        else {
            console.log('nist')
        }
    }

    render() {
        let offers=[]
        const {dialogDetail}=this.state
        const customDialog={
            button:{
                text:'',
                backgroundColor:'transparent',
                bottomFontSize:'15px',
                buttonTextColor:'red',
                borderColor:'transparent'
            },
            data:{
                dialog:dialogDetail,
            }
        }
        const handleClose=(()=>{
            this.setState({
                showDialog:false,
            })
        })
        if ( this.state.marketDataLoaded ){
            offers=this.state.marketDataLoaded
        }
        const obg ={
            dialog:{
                success:false,
                ok:null,
                message:this.state.resDialogText,
                style: {
                    background: dialogBackground,
                    borderColor: dialogBorderColor,
                    contentColor: dialogContentColor,
                    contentTextColor: dialogContentTextColor,
                    type: "danger",
                },
                cancel:{
                    action: "#cancel",
                    text: 'باشه'
                }
            }
        }
        const resCustomDialog={
            button:{
                text:'',
                backgroundColor:'transparent',
                bottomFontSize:'15px',
                buttonTextColor:'red',
                borderColor:'transparent'
            },
            data:{
                dialog:obg.dialog,
            }
        }
        // this.setState({
        //     resDialog:true,
        //     resDialogDetail:obg.dialog
        // })
        return(
            <Grid direction={"column"} item container style={this.state.style.root}>
                <Dialog
                    // disableBackdropClick
                    open={this.state.resDialog}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    style={{background:'transparent !important'}}
                    PaperProps={{
                        style: {
                            backgroundColor: 'transparent',
                            boxShadow: 'none',
                        },
                    }}
                >
                    <DialogContent>
                        <CustomDialog action={this.handleShopDialogAction} data={resCustomDialog}/>
                    </DialogContent>
                </Dialog>
                <Dialog
                    // disableBackdropClick
                    open={this.state.showDialog}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    style={{background:'transparent !important'}}
                    PaperProps={{
                        style: {
                            backgroundColor: 'transparent',
                            boxShadow: 'none',
                        },
                    }}
                >
                    <DialogContent>
                        <ShopDialog action={this.handleDialogAction} data={customDialog}/>
                    </DialogContent>
                </Dialog>
                {
                    this.state.marketDataLoaded &&
                    <Grid item sm={12} xs={12} direction={"column"} justify={'center'} container
                          style={{flex: '1', minHeight: '0'}}>
                        <Grid item container>
                            <Toolbar increment={false} type='sideToolbar'/>
                        </Grid>
                        <Grid item alignItems={"center"} container xs={12} justify={"center"} sm={12} className='scrollBar'
                              style={{flex: '1', minHeight: '0', overflow: 'auto',paddingBottom:'30px'}}>
                            <Grid item sm={12} xs={12} justify={'center'} alignItems={"center"} container
                                  onClick={()=>{
                                      this.openDialog(offers.banner)
                                  }}
                            style={{
                                backgroundImage:"url("+ EmptyWood+")",
                                backgroundSize: '100% 100%',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: '50% 50%',
                                padding:'15px',
                                maxHeight:'180px'
                            }}>
                                <img src={offers.banner.url} style={{width:'100%',borderRadius:'15px'}} alt=""/>
                            </Grid>
                                {
                                    offers.list.map(data => {
                                        return(
                                            <Grid justify={"center"} alignItems={"center"} container>
                                                <Grid  sm={11} xs={11} container alignItems={"center"} justify={"center"}
                                                        className='market-intro-banner'
                                                      style={{
                                                          backgroundImage:"url("+ GoldBanner+")",
                                                          backgroundSize: '100% 100%',
                                                          backgroundRepeat: 'no-repeat',
                                                          backgroundPosition: '50% 50%',
                                                          // padding:'15px',
                                                          // maxHeight:'180px'
                                                      }}
                                                >
                                                    {data.title}
                                                </Grid>
                                                <Grid  className='offer-section' sm={12} xs={12}
                                                      justify={'space-around'}
                                                      container style={{
                                                    //       marginBottom: '100px',
                                                    // height:'50px',
                                                    backgroundColor:''}}>
                                                    {
                                                        data.items.map((singleOffer,index) => {
                                                            return (
                                                                <Grid sm={3} xs={3} onClick={()=>{
                                                                    this.openDialog(singleOffer)
                                                                }}
                                                                      style={{height:'100%'}}
                                                                >
                                                                    <SingleOffer data={singleOffer}/>
                                                                </Grid>
                                                            )
                                                        })
                                                    }
                                                </Grid>
                                            </Grid>

                                            )
                                    })
                                }
                            {/*// </Grid>*/}
                        </Grid>
                    </Grid>
                }
                {
                    !this.state.marketDataLoaded &&
                    <Grid m={2} xs={2} container alignItems={"center"} direction={"row-reverse"} justify={"center"}
                          style={{position:'relative',
                              top:'50%',left:'50%',transform:'translate(-50%,-50%)'}}
                    >
                        <Grid item container justify={"center"} style={{
                            position:'absolute',
                        }}>
                            <PicoLoader/>
                        </Grid>
                    </Grid>

                }
            </Grid>
        )
    }
}
const mapStateToProps=state=>({
    UserData:state.UserData
})
export default connect(mapStateToProps,{data,dialog})(withRouter(MarketIndex))
// export default MarketIndex